module.exports = __webpack_public_path__ + "img/icons/outlook-login-4585943ce4255b6b4efb637877e69fb7.svg";